import { useNavigate } from 'react-router-dom';
import RecruiterLayout from '@/components/RecruiterLayout';
import { EntityManager } from '@/components/entity';

const ClientManagement = () => {
  const navigate = useNavigate();

  return (
    <RecruiterLayout>
      <EntityManager
        entityName="clients"
        onRowClick={(client) => navigate(`/recruiter/clients/${client.id}`)}
      />
    </RecruiterLayout>
  );
};

export default ClientManagement;
